import { useQuery } from '@tanstack/vue-query'
import type { ResponseByPath, QueryParamsByPath } from '@@/api/types'
import { useApi } from '@/composables/useApi.js'

const CONTENT_TYPES_URL = '/{provet_id}/api/content_types'

export type ContentTypeListResponse = ResponseByPath<
  'get',
  typeof CONTENT_TYPES_URL
>

export type ContentTypeListQueryParams = QueryParamsByPath<
  'get',
  typeof CONTENT_TYPES_URL
>

const contentTypeKeys = {
  all: ['contentTypes'] as const,
  lists: () => [...contentTypeKeys.all, 'list'] as const,
  list: (params: MaybeRef<ContentTypeListQueryParams>) =>
    [...contentTypeKeys.lists(), params] as const,
}

export function useContentTypeQuery({
  modelName,
  appLabel = 'health',
  enabled = true,
}: {
  modelName: MaybeRef<string>
  appLabel?: MaybeRef<string>
  enabled?: MaybeRef<boolean>
}) {
  const api = useApi()
  const route = useRoute()

  const queryParams = computed<ContentTypeListQueryParams>(() => ({
    'filter[model]': unref(modelName),
    'filter[app_label]': unref(appLabel),
    'page[size]': 1,
  }))

  const query = useQuery({
    queryKey: contentTypeKeys.list(queryParams),
    enabled,
    queryFn: () =>
      api((client) =>
        client.GET(CONTENT_TYPES_URL, {
          params: {
            path: { provet_id: route.params.provetId },
            query: queryParams.value,
          },
        }),
      ),
    select: (response) => response.data.at(0)?.id || null,
  })

  return reactive(query)
}
